An array of `Location` identifiers.

Scheme requirements:

- The `seekAnz` scheme requires exactly one element.
